(function () {
  const STORAGE_KEY = 'bc_collection';

  function saveCollection(title, url) {
    if (!title || !url) return;
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ title, url }));
    } catch (error) {
      /* ignore storage errors */
    }
  }

  function readCollection() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      return null;
    }
  }

  function isExcludedCollectionUrl(url) {
    if (!url) return true;
    const excluded = [
      '/collections/all',
      '/collections/best-selling-products',
      '/collections/best-selling',
      '/collections/best-sellers',
      '/collections/all-catalogue',
      '/collections/frontpage',
    ];
    return excluded.some((path) => url.endsWith(path) || url.includes(`${path}/`));
  }

  function isAllowedProductCollection(link, url) {
    const allowed = (link.dataset.collectionUrls || '')
      .split('|')
      .filter(Boolean);
    if (!allowed.length) return !isExcludedCollectionUrl(url);
    return allowed.includes(url);
  }

  function trackCollectionPage() {
    const data = document.querySelector('[data-track-collection]');
    if (!data) return;
    saveCollection(data.dataset.collectionTitle, data.dataset.collectionUrl);
  }

  function updateProductBreadcrumbs() {
    const breadcrumb = document.querySelector('[data-product-breadcrumbs]');
    if (!breadcrumb || breadcrumb.dataset.hasCollection === 'true') return;

    const stored = readCollection();
    if (!stored?.title || !stored?.url || isExcludedCollectionUrl(stored.url)) return;

    const homeLink = breadcrumb.querySelector('a[href]');
    if (!homeLink) return;

    const homeHref = homeLink.getAttribute('href');
    const homeText = homeLink.textContent;

    breadcrumb.innerHTML = '';

    const newHomeLink = document.createElement('a');
    newHomeLink.href = homeHref;
    newHomeLink.textContent = homeText;
    breadcrumb.appendChild(newHomeLink);

    const sep1 = document.createElement('span');
    sep1.className = 'product-breadcrumbs__sep';
    sep1.setAttribute('aria-hidden', 'true');
    sep1.textContent = '>';

    const collectionLink = document.createElement('a');
    collectionLink.href = stored.url;
    collectionLink.textContent = stored.title;

    const sep2 = document.createElement('span');
    sep2.className = 'product-breadcrumbs__sep';
    sep2.setAttribute('aria-hidden', 'true');
    sep2.textContent = '>';

    breadcrumb.appendChild(sep1);
    breadcrumb.appendChild(collectionLink);
    breadcrumb.appendChild(sep2);
  }

  function updateProductViewCollectionLink() {
    const link = document.querySelector('[data-product-view-collection]');
    if (!link) return;

    if (link.dataset.hasCollection === 'true') return;

    const stored = readCollection();
    if (!stored?.url || isExcludedCollectionUrl(stored.url)) return;
    if (!isAllowedProductCollection(link, stored.url)) return;

    link.href = stored.url;
    link.dataset.collectionTitle = stored.title || '';
    link.dataset.collectionUrl = stored.url;

    if (stored.title) {
      const prefix = link.getAttribute('data-view-collection-label') || 'View collection';
      link.setAttribute('aria-label', `${prefix} ${stored.title}`);
    }
  }

  function init() {
    trackCollectionPage();
    updateProductBreadcrumbs();
    updateProductViewCollectionLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
